module.exports = __webpack_public_path__ + "img/qiu1@2x.8dd5ff6d.png";